import React from 'react'

interface BoldCheckMarkProps {
  checked: boolean
  /** 한 변의 길이(px). */
  size?: number
  className?: string
}

/**
 * 굵은 네모 체크 표식. **누르는 기능이 없다** — 그림만 그린다.
 *
 * 줄 전체를 누르는 자리(키워드 고르기·신고 사유)에서는 표식이 스스로
 * 손짓을 받으면 안 된다. 줄과 표식이 각자 반응하면 한 번 누른 것이 두 번
 * 처리된다. 그래서 누르는 일은 줄이 맡고 표식은 모양만 맡는다.
 * 표식 하나가 곧 버튼인 자리는 [BoldCheckbox] 를 쓴다.
 *
 * **그림 두 장을 겹쳐 두고 `opacity` 로만 바꾼다. `src` 를 갈아끼우지 않는다.**
 * 사파리는 이미지를 비동기로 그려서, `src` 가 바뀌면 옛 그림이 즉시
 * 사라지고 새 그림은 다음 프레임 뒤에 올라온다 — 체크가 한두 프레임
 * 비어 보이다가 채워졌다. 파일이 3KB·104px 라 내려받는 문제가 아니라
 * 그리는 차례 문제여서, 캐시가 있어도 **누를 때마다** 생겼다.
 *
 * 사라지는 쪽을 지우지 않고 `opacity-0` 으로만 두는 것이 요점이다 —
 * 지웠다 그리면 같은 문제가 돌아온다.
 */
const BoldCheckMark: React.FC<BoldCheckMarkProps> = ({
  checked,
  size = 26,
  className = '',
}) => (
  <span
    className={`relative shrink-0 block ${className}`}
    style={{ width: size, height: size }}
    aria-hidden="true"
  >
    <img
      src="/images/checkbox-bold-unchecked.png"
      alt=""
      className={
        'absolute inset-0 w-full h-full object-contain' +
        (checked ? ' opacity-0' : '')
      }
    />
    <img
      src="/images/checkbox-bold-filled.png"
      alt=""
      className={
        'absolute inset-0 w-full h-full object-contain' +
        (checked ? '' : ' opacity-0')
      }
    />
  </span>
)

export default BoldCheckMark
